<div class="form-container">
  @for (item of textForms; track item.title) {
  <app-aw-text-form
    class="input"
    [value]="item.value"
    [required]="item.required"
    [title]="item.title"
    [readOnly]="item.readOnly"
    (textEntry)="item.textEntryActionHandler($event)"
  >
  </app-aw-text-form>
  }
</div>
